import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import { fromJS } from 'immutable';

export default (rootReducer, rootSaga) => {
  let store;

  const initialState = fromJS({});

  const sagaMiddleware = createSagaMiddleware();

  if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger({
      collapsed: false,
      stateTransformer: state => state.toJS(),
    });

    store = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware, logger));
  } else {
    store = createStore(rootReducer, initialState, applyMiddleware(sagaMiddleware));
  }

  sagaMiddleware.run(rootSaga);

  return store;
};
